var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUploadingStep = function SvgUploadingStep(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 295.271 295.441"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    stroke: "#707070",
    strokeWidth: 0.3,
    d: "M240.86 89.179c.1-1.666.152-3.357.152-5.107a83.565 83.565 0 0 0-163.5-24.48 70 70 0 0 0-3.628-.1 73.734 73.734 0 0 0 0 147.467h44.294a4.916 4.916 0 0 0 0-9.831H73.883a63.9 63.9 0 0 1 0-127.8 66 66 0 0 1 6.783.369 5.014 5.014 0 0 0 5.26-3.692 73.733 73.733 0 0 1 145.256 18.067 67 67 0 0 1-.595 9.168 4.917 4.917 0 0 0 4.871 5.579h.639a49.156 49.156 0 0 1 0 98.311h-58.655a4.916 4.916 0 0 0 0 9.831h58.657a58.987 58.987 0 0 0 4.763-117.782Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff9d00",
    d: "m206.707 150.953-59.09-59.085-59.09 59.085 6.956 6.955 47.218-47.224V295.44h9.832V110.685l47.218 47.224Z",
    opacity: 0.5
  })));
};
export default SvgUploadingStep;